export default __webpack_public_path__ + "static/media/Q08_雀躍跳動小小的綠繡眼.4b273fb6.mp4";